<template>
  <page-header class="px-10">
    <h1>Uus huviring</h1>
  </page-header>
  <v-sheet class="d-flex flex-column mx-auto pa-10">
    <v-form ref="form">
      <v-file-input
          v-model="selectedImage"
          label="Sisesta pilt"
          variant="outlined"
          prepend-icon="mdi-camera"
          accept="image/*"
          :loading="uploadingImage"
          @update:modelValue="uploadImage"
      ></v-file-input>
      <p v-if="uploadError" class="error-text">{{ uploadError }}</p>
      <v-btn
          class="mb-4"
          color="eraklient"
          variant="outlined"
          :loading="loadingCloudinaryImages"
          @click="fetchCloudinaryImages"
      >
        Lae pildid
      </v-btn>
      <p v-if="cloudinaryError" class="error-text">{{ cloudinaryError }}</p>
      <div v-if="cloudinaryImages.length" class="cloudinary-gallery">
        <button
            v-for="image in cloudinaryImages"
            :key="image.public_id"
            type="button"
            class="cloudinary-item"
            :class="{ selected: post.image === image.url }"
            @click="openImageCropperFromUrl(image.url)"
        >
          <img :src="image.url" :alt="image.public_id"/>
          <span
              class="cloudinary-delete"
              @click.stop.prevent="openDeleteCloudinaryDialog(image)"
          >
            <v-icon size="16">mdi-delete</v-icon>
          </span>
        </button>
      </div>
      <v-dialog v-model="deleteImageDialog" width="auto" transition="none">
        <v-card min-width="360">
          <v-toolbar color="white" title="Kinnitus">
            <v-btn icon="mdi-close" @click="closeDeleteCloudinaryDialog"></v-btn>
          </v-toolbar>
          <v-card-text>
            <v-alert type="warning" variant="tonal" border="start" prominent>
              Kas oled kindel, et soovid selle pildi kustutada?
            </v-alert>
          </v-card-text>
          <v-divider></v-divider>
          <div class="ma-4">
            <v-btn
                class="text-none mr-4 font-weight-bold"
                color="error"
                min-width="92"
                rounded
                :loading="deletingPublicId === pendingDeleteImage?.public_id"
                @click="confirmDeleteCloudinaryImage"
            >
              Jah
            </v-btn>
            <v-btn class="text-none font-weight-bold" min-width="92" rounded @click="closeDeleteCloudinaryDialog">
              Ei
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <selected-image-preview :src="post.image" label="Valitud pilt" @remove="post.image = ''"></selected-image-preview>
      <image-cropper-dialog
          v-model="cropDialogVisible"
          :src="cropSource"
          title="Kärbi teenuse pilti"
          @confirm="handleCropConfirm"
          @cancel="closeImageCropper"
      ></image-cropper-dialog>
      <v-tabs v-model="tab" bg-color="eraklient">
        <v-tab value="one">EST</v-tab>
        <v-tab value="two">ENG</v-tab>
        <v-tab value="three">RUS</v-tab>
      </v-tabs>
      <v-window class="py-5" v-model="tab">
        <v-window-item value="one">
          <v-text-field
              v-model=post.title
              label="Pealkiri"
              :rules="rules"
              required
              variant="outlined"
          ></v-text-field>
          <tiptap v-model="post.body"/>
        </v-window-item>
        <v-window-item value="two">
          <v-text-field
              v-model=post.title_en
              label="Pealkiri(en)"
              required
              variant="outlined"
          ></v-text-field>
          <tiptap v-model="post.body_en"/>
        </v-window-item>
        <v-window-item value="three">
          <v-text-field
              v-model=post.title_ru
              label="Pealkiri(ru)"
              required
              variant="outlined"
          ></v-text-field>
          <tiptap v-model="post.body_ru"/>
        </v-window-item>
      </v-window>
      <v-btn color="success" @click="addService" block class="mt-2">Lisa</v-btn>
    </v-form>
  </v-sheet>
</template>

<script>
import ImageCropperDialog from "@/components/ImageCropperDialog";
import SelectedImagePreview from "@/components/SelectedImagePreview";
import Tiptap from "@/components/Tiptap";
import PageHeader from "@/components/PageHeader";
export default {
  name: "AddHuviring",
  components: {ImageCropperDialog, PageHeader, SelectedImagePreview, Tiptap},
  data() {
    return {
      valid: false,
      tab: null,
      selectedImage: null,
      uploadingImage: false,
      uploadError: "",
      loadingCloudinaryImages: false,
      cloudinaryError: "",
      cloudinaryImages: [],
      deletingPublicId: null,
      deleteImageDialog: false,
      pendingDeleteImage: null,
      cropDialogVisible: false,
      cropSource: "",
      cropSourceObjectUrl: "",
      cropSourceName: "cropped-image.jpg",
      post: {
        image: "",
        title: "",
        title_en: null,
        title_ru: null,
        body: "",
        body_en: null,
        body_ru: null
      },
      rules: [
        value => {
          if (value) return true
          return 'Ei saa olla tühi.'
        },
      ]
    }
  },
  methods: {
    openImageCropperFromFile(fileInput) {
      const file = Array.isArray(fileInput) ? fileInput[0] : fileInput;
      if (!file) return;

      this.closeImageCropper();
      this.cropSourceObjectUrl = URL.createObjectURL(file);
      this.cropSource = this.cropSourceObjectUrl;
      this.cropSourceName = file.name || "cropped-image.jpg";
      this.cropDialogVisible = true;
      this.selectedImage = null;
    },
    openImageCropperFromUrl(url) {
      if (!url) return;

      this.closeImageCropper();
      this.cropSource = url;
      this.cropSourceName = "cropped-image.jpg";
      this.cropDialogVisible = true;
    },
    closeImageCropper() {
      this.cropDialogVisible = false;
      this.cropSource = "";

      if (this.cropSourceObjectUrl) {
        URL.revokeObjectURL(this.cropSourceObjectUrl);
        this.cropSourceObjectUrl = "";
      }
    },
    handleCropConfirm({ dataUrl }) {
      this.post.image = dataUrl;
      this.closeImageCropper();
    },
    async fetchCloudinaryImages() {
      this.loadingCloudinaryImages = true;
      this.cloudinaryError = "";
      try {
        const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/uploads/images?t=${Date.now()}`, {
          method: "GET",
          credentials: "include",
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || "Failed to load Cloudinary images");
        this.cloudinaryImages = data;
      } catch (error) {
        this.cloudinaryError = "Cloudinary piltide laadimine ebaõnnestus";
        console.log(error);
      } finally {
        this.loadingCloudinaryImages = false;
      }
    },
    async uploadImage(fileInput) {
      this.openImageCropperFromFile(fileInput);
    },
    openDeleteCloudinaryDialog(image) {
      this.pendingDeleteImage = image;
      this.deleteImageDialog = true;
    },
    closeDeleteCloudinaryDialog() {
      this.deleteImageDialog = false;
      this.pendingDeleteImage = null;
    },
    async confirmDeleteCloudinaryImage() {
      const image = this.pendingDeleteImage;
      if (!image?.public_id) return;

      this.cloudinaryError = "";
      this.deletingPublicId = image.public_id;

      try {
        const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/uploads/image`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ public_id: image.public_id }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || "Image delete failed");

        this.cloudinaryImages = this.cloudinaryImages.filter((item) => item.public_id !== image.public_id);
        if (this.post.image === image.url) {
          this.post.image = "";
        }
      } catch (error) {
        this.cloudinaryError = "Pildi kustutamine ebaõnnestus";
        console.log(error);
      } finally {
        this.deletingPublicId = null;
        this.closeDeleteCloudinaryDialog();
      }
    },
    async addService() {
      const { valid } = await this.$refs.form.validate()

      if (valid) {
        var data = {
          image: this.post.image,
          title: this.post.title,
          title_en: this.post.title_en,
          title_ru: this.post.title_ru,
          body: this.post.body,
          body_en: this.post.body_en,
          body_ru: this.post.body_ru,
        };
        fetch(`${process.env.VUE_APP_SERVER_URL}/api/services/huviringid`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
            .then((response) => {
              console.log(response.data);
              location.assign("/teenused/huviringid");
            })
            .catch((e) => {
              console.log(e);
              console.log("error");
            });
      }
    },
  },
}
</script>

<style scoped>
.error-text {
  color: #b00020;
  margin-top: -8px;
  margin-bottom: 12px;
}

.cloudinary-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}

.cloudinary-item {
  position: relative;
  border: 2px solid transparent;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  padding: 0;
  background: transparent;
}

.cloudinary-item.selected {
  border-color: #4caf50;
}

.cloudinary-item img {
  display: block;
  width: 100%;
  height: 120px;
  object-fit: cover;
}

.cloudinary-delete {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  color: #fff;
  background: rgba(176, 0, 32, 0.85);
}

@media (max-width: 820px) {
  .pa-10 {
    padding: 0 20px !important;
  }
}
</style>
